import React, { Fragment } from 'react';
import Breadcrumb from '../Navigation/Breadcrumbs/Breadcrumb';
import { BreadcrumbLink } from '../Navigation/Breadcrumbs/BreadcrumbLink';

const PersonalDataEditBreadcrumb = () => {

    return (
        <Breadcrumb>
            <Fragment>
                <BreadcrumbLink
                    label="Stammdaten"
                    path="/account/profile"
                    icon="settings"
                />
                <BreadcrumbLink
                    label="Persönliche Daten bearbeiten"
                    path="/me/edit"
                />
            </Fragment>
        </Breadcrumb>
    );
};

export default PersonalDataEditBreadcrumb;
